(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SCVConnectorBase", [], factory);
	else if(typeof exports === 'object')
		exports["SCVConnectorBase"] = factory();
	else
		root["SCVConnectorBase"] = factory();
})(this, function() {
return 